import { render } from "./TagList.vue?vue&type=template&id=7f2be63c&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"

import "./TagList.vue?vue&type=style&index=0&id=7f2be63c&scoped=true&lang=css"

import exportComponent from "/Users/warths/refonte-manager-cli/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2be63c"]])

export default __exports__